import { HOK_GAME_ID } from './index';

const userCacheKey = 'CAMP_HOK_USER_INFO';

let userCache: UserInfo | null = null;

interface UserInfo {
  userId?: string;
  token?: string;
  role?: RoleInfo;
}

interface RoleInfo {
  channel?: number;
  channelAccessToken?: string;
  characName?: string;
  headUrl?: string;
  openId?: string;
  partition?: string;
  token?: string;
  uid?: string;
}

/**
 * 获取登录态参数
 * @returns
 */
export const getBaseHeaderParams = () => {
  const userInfo = getUserAuthInfo();
  const language = window.navigator.language;

  if (userInfo?.userId) {
    const encodeParam = (window as any)?.__TCSJ__?.getEncodeParam(userInfo.userId) || '';
    if (encodeParam) {
      return {
        gameId: HOK_GAME_ID,
        gameOpenId: userInfo.userId,
        campToken: userInfo.token,
        encodeParam,
        'Camp-Language': language,
        campSource: 'HOK-CAMP',
      };
    }
  }
  const specialEncodeParam = (window as any)?.__TCSJ__?.getEncodeParam() || '';
  return {
    gameId: HOK_GAME_ID,
    specialEncodeParam,
    'Camp-Language': language,
    campSource: 'HOK-CAMP',
  };
};

// /**
//  * 获取登录态参数
//  * @returns
//  */
// export const getBaseHeaderParams = () => {
//   const specialEncodeParam = (window as any)?.__TCSJ__?.getEncodeParam() || '';
//   return {
//     gameId: HOK_GAME_ID,
//     specialEncodeParam,
//   };
// };

/**
 * 缓存登陆后的信息
 * @param userId
 * @param campToken
 */
export const setUserAuthInfo = (userId: string, campToken: string, roleInfo: RoleInfo, cache: boolean) => {
  console.log('setUserAuthInfo', userId, campToken, roleInfo);
  try {
    userCache = { userId, token: campToken, role: roleInfo };
    if (window.localStorage && userId && campToken && cache) {
      window.localStorage.setItem(userCacheKey, btoa(encodeURIComponent(JSON.stringify(userCache))));
    }
    if (window.sessionStorage && userId && campToken) {
      window.sessionStorage.setItem(userCacheKey, btoa(encodeURIComponent(JSON.stringify(userCache))));
    }
  } catch (error) {
    console.warn(error);
  }
};

/**
 * 获取缓存的登陆态信息
 */
export const getUserAuthInfo = (): UserInfo | null => {
  try {
    if (userCache?.userId) {
      return userCache;
    }
    const cache = window.sessionStorage?.getItem(userCacheKey) || window.localStorage?.getItem(userCacheKey);
    if (cache) {
      return JSON.parse(decodeURIComponent(atob(cache)));
    }
    return null;
  } catch (error) {
    console.warn(error);
    return null;
  }
};

export const removeUserAuthInfo = () => {
  try {
    userCache = null;
    if (window.localStorage) {
      window.localStorage.removeItem(userCacheKey);
    }
    if (window.sessionStorage) {
      window.sessionStorage.removeItem(userCacheKey);
    }
  } catch (error) {
    console.warn(error);
  }
};

export const rsaEncrypt = (text: string) => {
  if ((window as any).__TCSJ__) {
    return (window as any).__TCSJ__.rsaEncrypt(text);
  }
  return '';
};
